import complianceReportRouter from './modules/complianceReportRouter'

const complianceManageRouter = [].concat(complianceReportRouter)
export default complianceManageRouter
